<template>
  <div
    class="option-card"
    :class="[
      layout === 'horizontal' ? 'flex-row' : 'flex-col',
      {
        loading,
        disabled
      },
    ]"
    v-hover-intent="{
      onEnter: () => $emit('preview', option),
      onExit: () => $emit('preview', null)
    }"
    @click="handleClick"
  >
    <template v-if="!$slots.default">
      <aha-spinner
        :variant="'dark'"
        size="sm"
        class="option-card-loader"
        :class="{
          'visible': loading,
        }"
      />
      <div class="option-card-img">
        <aha-icon
          :name="option.icon"
          maintainColor
        />
      </div>
      <div class="option-card-title font-bold text-base">
        {{ option.name }}
      </div>
    </template>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'FeatureOptionCard',
  props: {
    option: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      default: 'vertical',
      validator: (value) => ['vertical', 'horizontal'].includes(value),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.disabled || this.loading) return

      this.$emit('click', this.option)
    },
  },
}
</script>

<style lang="scss" scoped>
.option-card {
  @apply flex justify-center items-center relative;
  @apply p-5;
  @apply text-center cursor-pointer bg-white-100;
  @apply border border-solid border-secondary-20 rounded-xl hover:border-primary-90;
  min-height: 86px;

  &.loading {
    .option-card-img {
      @apply invisible;
    }
  }

  &.disabled,
  &.loading {
    @apply cursor-not-allowed opacity-50;
  }
}

.option-card-img {
  @apply flex justify-center items-center;
  @apply w-11 h-11;
}

.option-card-loader {
  visibility: hidden;
  position: absolute;
  top: calc(50% - 20px);
  left: 50%;
  transform: translateX(-50%);

  &.visible {
    visibility: visible;
  }
}
</style>
